import React from 'react';

import moment from 'moment';
import { Input, Tooltip, Select, Button, DatePicker, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { graphql, withApollo } from 'react-apollo';

import getOrganismoPorId from '../../../graphql/querys/organismos/getOrganismoPorId.graphql';
import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getSupervisorDeUsuario from '../../../graphql/querys/auth/getSupervisorDeUsuario.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@graphql(getUsuario)
class FormCrearTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      organismo: {},
      listaUsuarios: [],
      supervisor: {},
    };

    // console.log("ENTRE!");
    props.client
      .query({
        query: getOrganismoPorId,
        variables: {
          _id: props.data.getUsuario.organismo._id,
        },
      })
      .then(res => {
        // console.log("LA RESPUESTA ES....");
        // console.log(res);

        if (res.data.getOrganismoPorId) {
          props.client
            .query({
              query: getSupervisorDeUsuario,
              variables: {
                _id: props.data.getUsuario._id,
                idOrganismo: props.data.getUsuario.organismo._id,
              },
            })
            .then(resSupervisor => {
              this.setState({
                ...this.state,
                organismo: res.data.getOrganismoPorId,
                supervisor: resSupervisor.data.getSupervisorDeUsuario,
              });
            })
            .catch(err => {
              console.log('error a la hora de obtener el supervisor');
              console.log(err);

              let yo = this;

              Modal.error({
                title: 'Error en la obtencion del supervisor',
                content:
                  'Por favor, compruebe que el organismo al que usted pertenece posee un supervisor configurado',
                onOk() {
                  yo.props.history.push('/');
                },
              });
            });
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR EL ORGANISMO!');
        console.log(err);

        let yo = this;
        Modal.error({
          title: 'Error en la obtencion del organismo',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          onOk() {
            yo.props.history.push('/');
          },
        });
      });

    props.client
      .query({
        query: getUsuariosPorOrganismo,
        variables: {
          idOrganismo: props.data.getUsuario.organismo._id,
        },
      })
      .then(res => {
        // console.log("LA RESPUESTA ES....");
        // console.log(res);

        this.setState({
          ...this.state,
          listaUsuarios: res.data.getUsuariosPorOrganismo,
        });
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR EL ORGANISMO!');
        console.log(err);
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleChange = valor => {
    this.setState({
      ...this.state,
      itemTipoSeleccionado: valor,
    });
  };

  crearOpciones(usuario) {
    return (
      <Option key={usuario._id} value={usuario._id}>
        {usuario.nombre + ' ' + usuario.apellido}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let usuario = this.props.data.getUsuario;
    let organismoUsuario = this.state.organismo;
    let listaUsuariosOrganismo = this.state.listaUsuarios;

    if (listaUsuariosOrganismo) {
      // eslint-disable-next-line no-unused-vars
      var opciones = _.map(listaUsuariosOrganismo, this.crearOpciones);
    } else {
      return <Loading />;
    }

    return (
      <div>
        <h1 className="tituloForm">Datos de la Licencia</h1>
        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40, color: '#000000' }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Lugar
                <Tooltip title="Seleccione el organismo">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el organismo!',
                },
              ],
              initialValue: organismoUsuario._id,
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione un organismo"
                optionFilterProp="children"
                disabled={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={organismoUsuario._id} value={organismoUsuario._id}>
                  {organismoUsuario.nombre}
                </Option>
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Empleado solicitante
                <Tooltip title="Solicitante">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idSolicitante', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el solicitante!',
                },
              ],
              initialValue: usuario._id,
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Usuario Solicitante"
                optionFilterProp="children"
                disabled={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={usuario._id} value={usuario._id}>
                  {usuario.nombre + ' ' + usuario.apellido}
                </Option>
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Superior
                <Tooltip title="Superior que concede">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idSupervisor', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el superior!',
                },
              ],
              initialValue: this.state.supervisor
                ? this.state.supervisor._id
                : '',
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Supervisor a ser notificado"
                optionFilterProp="children"
                disabled={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {this.state.supervisor && (
                  <Option
                    key={this.state.supervisor._id}
                    value={this.state.supervisor._id}
                  >
                    {this.state.supervisor.nombre +
                      ' ' +
                      this.state.supervisor.apellido}
                  </Option>
                )}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha Inicio
                <Tooltip title="Fecha de inicio ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaInicio', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese la fecha inicio!',
                },
              ],
            })(
              <DatePicker
                format="DD-MM-YYYY"
                placeholder="Seleccionar Fecha"
                style={{ color: '#000000' }}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha Fin
                <Tooltip title="Fecha de fin ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaFin', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese la fecha fin!',
                },
              ],
            })(
              <DatePicker
                format="DD-MM-YYYY"
                placeholder="Seleccionar Fecha"
                style={{ color: '#000000' }}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Motivo
                <Tooltip title="Motivo de la licencia ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('motivo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el motivo de la licencia!',
                },
              ],
            })(<Input style={{ width: 500, color: '#000000' }} />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    // console.log("Las que me llega es...");
    // console.log(props);
    return {
      fechaInicio: Form.createFormField({
        value: props.datos ? moment(props.datos.fechaInicio) : moment(),
      }),
      fechaFin: Form.createFormField({
        value: props.datos ? moment(props.datos.fechaFin) : moment(),
      }),
      motivo: Form.createFormField({
        value: props.datos ? props.datos.motivo : '',
      }),
    };
  },
})(withApollo(FormCrearTraspaso));
